import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NumberUtils } from "src/app/common/utils/number.utils";

@Component({
  standalone: false,
  selector: "wfm-esp-validation-indicator-cell-v2",
  templateUrl: "./validation-indicator-cell-v2.component.html",
  styleUrls: ["./validation-indicator-cell-v2.component.css"]
})
export class ValidationIndicatorCellComponentV2 implements OnInit {

  public params: any;
  public validationSum: any;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  agInit(params: any): void {
    this.params = params;
    // Format according to the locale.
    this.validationSum = NumberUtils.formatNumberIfNecessary(params.context.columnSum(this.params.colDef.field),
      params.locale, params.metadata.decimal);
  }

  /**
   * Accessible name for the validation-error icon button so screen readers
   * announce the error when keyboard focus reaches it (WCAG 2.1.1 / 4.1.2).
   * Mirrors the visual popover text (same translation keys + column sum).
   */
  get validationErrorLabel(): string {
    return [
      this.translate.instant("plan.dist.cell.validation.line1"),
      this.translate.instant("plan.dist.cell.validation.line2"),
      this.translate.instant("plan.dist.cell.validation.line3") + this.validationSum + "%"
    ].join(" ");
  }

  isValidIndicator(){
    let context = this.params.context;
    //return context.isGridValid()==false;
    return context.isGridValid()==false &&
      context.isValidColumn(this.params.colDef.field)==false &&
      this.params.api.getFocusedCell() &&
      this.params.api.getFocusedCell().rowIndex==this.params.rowIndex &&
      this.params.api.getFocusedCell().column.colId==this.params.column.colId
  }

  /**
   * Action separation (WCAG 2.1.1 / Dragon voice control): the validation-error
   * "i" icon lives inside an EDITABLE cell. A pointer activation (mouse or a
   * Dragon "click <name>" command) opens the ngbPopover, but the same event
   * bubbles to the AG Grid cell, which changes focus/selection and starts the
   * cell edit — that re-render tears down the icon/popover so its content is
   * never revealed. Stop the icon's pointer events from reaching the cell so a
   * click performs ONLY the icon action (open the popover); the cell edit
   * action stays reachable by activating the cell itself. Keyboard activation
   * is handled separately by the grid's suppressGridTabToFocusChildren handler.
   */
  stopCellAction(event: Event){
    event.stopPropagation();
  }

  refresh(){
    return false;
  }


}
